import React, { useState } from "react";
import { Admin, Resource, CustomRoutes, defaultTheme } from "react-admin";
import { HashRouter, Routes, Route } from "react-router-dom";
import PublicMenu from "./menu/PublicMenu";
import { createTheme } from "@mui/material/styles";
import ExtraSectionCreate from "./menu/extraSections/ExtraSectionCreate";
import ReferansDashboard from "./referans/ReferansDashboard";
import BayilikSistemi from "./bayilik/bayilikSistemi";


import LoginPage from "./LoginPage";
import dataProvider from "./dataProvider";
import MuhtarDashboard from "./MuhtarDashboard";
import CustomLayout from "./CustomLayout";
import ResetPasswordPage from "./pages/ResetPasswordPage";
import ReferansResetPasswordPage from "./referans/ReferansResetPasswordPage";
import ReferansChangePasswordPage from "./referans/ReferansChangePasswordPage";
import KurumResetPasswordPage from "./pages/KurumResetPasswordPage";
import KurumChangePasswordPage from "./pages/KurumChangePasswordPage";
import QrKodPage from "./pages/QrKodPage";  // QR Kod sayfası
import Evraklarim from "./Evraklarim/evraklarim";
import SablonEkle from './Evraklarim/SablonEkle';
import SiparislerPage from "./menu/SiparislerPage";
import TelefonSiparisPanel from "./menu/TelefonSiparisPanel";

import MenuYonetimiPage from "./menu/MenuYonetimiPage";

import MezarliklarPage from "./mezar/MezarliklarPage";
import PublicCemetery from "./mezar/PublicCemetery";
import BeatyPanel from "./beaty/beatypanel";
import BeatyMenu from "./beaty/beatymenu";
import KasaPanel from "./kasa/KasaPanel";
import MessageCenter from "./pages/message";
import IsAgiPanel from "./pages/isAgiPanel";
import HotelYonetimiPage from "./hotel/HotelYonetimiPage";

// 🎓 Kurs, eğitim ve spor programları
import KursPanel from "./pages/KursPanel";


import Cari from "./pages/cari";
import StokTakip from "./stok/StokTakip";
import MarketplaceYonetimiPage from "./marketplace/MarketplaceYonetimiPage";

import EntegrasyonPanel from "./entegrasyon/EntegrasyonPanel";
import YazarKasaPanel from "./yazarkasa/YazarKasaPanel";
import MasaYonetimiPage from "./menu/MasaYonetimiPage";

import KurumList from "./components/KurumList";
import BizKimizPage from "./pages/BizKimizPage";
import MesyatFrontend from "./pages/mesyatfrontend";

import DuyuruCard from "./pages/DuyuruCard";
import { DuyurularPage, DuyuruEdit } from "./pages/DuyurularPage";
import { EtkinliklerPage, EtkinlikCreate, EtkinlikEdit } from "./pages/EtkinliklerPage";
import { AnaKategorilerPage, AnaKategoriCreate, AnaKategoriEdit } from "./pages/AnaKategorilerPage";
import { FaaliyetlerPage, FaaliyetCreate, FaaliyetEdit } from "./pages/FaaliyetlerPage";
import { IletisimPage, IletisimEdit, IletisimCreate } from "./pages/IletisimPage";
import { AnketList, AnketlerPage, AnketCreate, AnketEdit } from "./pages/AnketlerPage";
import BookingPage from "./pages/BookingPage";
import RestaurantTablesPage from "./pages/RestaurantTablesPage";
import RestaurantSettingsPage from "./pages/RestaurantSettingsPage";
// 🧾 MUHASEBE & SİGORTA
import MuhasebeDashboard from "./pages/MuhasebeDashboard";
import MuhasebeBelgeler from "./pages/MuhasebeBelgeler";
import SigortaPage from "./pages/SigortaPage";
import DijitalImzaView from "./dijitalimza/DijitalImzaView";


import { GeriBildirimlerPage, GeriBildirimEdit } from "./pages/GeriBildirimlerPage";
import AyarlarPage from "./pages/AyarlarPage";

import { KullanicilarPage, KullaniciShow } from "./pages/KullanicilarPage";
import AdminLogin from "./admin/AdminLogin";



const Hidden = () => null;

const myTheme = createTheme({
  ...defaultTheme,
  palette: {
    mode: "light",
    background: {
      default: "#f5f5f5",
      paper: "#ffffff"
    }
  }
});

// ✅ PERSONEL YETKİ KONTROLÜ
const getPanelUser = () => {
  try {
    return (
      JSON.parse(localStorage.getItem("kullanici") || "null") ||
      JSON.parse(localStorage.getItem("user") || "null") ||
      JSON.parse(localStorage.getItem("me") || "null") ||
      {}
    );
  } catch {
    return {};
  }
};

const can = (key) => {
  const user = getPanelUser();

  const isStaff =
    user?.is_staff_user === true ||
    user?.is_staff_user === "true";

  // Ana kurum / firma sahibi her şeyi görür
  if (!isStaff) return true;

  // Personel sadece izin verilenleri görür
  return user?.permissions?.[key] === true;
};

const NoPermission = () => (
  <>
    <style>
      {`
        @keyframes noPermFadeUp {
          from {
            opacity: 0;
            transform: translateY(18px) scale(0.98);
          }
          to {
            opacity: 1;
            transform: translateY(0) scale(1);
          }
        }

        @keyframes noPermPulse {
          0% {
            box-shadow: 0 0 0 0 rgba(37, 99, 235, 0.22);
          }
          70% {
            box-shadow: 0 0 0 14px rgba(37, 99, 235, 0);
          }
          100% {
            box-shadow: 0 0 0 0 rgba(37, 99, 235, 0);
          }
        }
      `}
    </style>

    <div
      style={{
        minHeight: "70vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: 24,
        background: "linear-gradient(135deg, #f8fafc 0%, #eef4ff 100%)",
      }}
    >
      <div
        style={{
          width: "100%",
          maxWidth: 520,
          background: "#ffffff",
          borderRadius: 24,
          padding: "34px 28px",
          textAlign: "center",
          border: "1px solid #e5e7eb",
          boxShadow: "0 24px 70px rgba(15, 23, 42, 0.12)",
          animation: "noPermFadeUp .45s ease-out",
        }}
      >
        <div
          style={{
            width: 78,
            height: 78,
            margin: "0 auto 18px",
            borderRadius: "50%",
            background: "linear-gradient(135deg, #1d4ed8, #f97316)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            color: "#fff",
            fontSize: 34,
            fontWeight: 900,
            animation: "noPermPulse 1.8s infinite",
          }}
        >
          🔒
        </div>

        <h2
          style={{
            margin: 0,
            fontSize: 26,
            fontWeight: 900,
            color: "#0f172a",
          }}
        >
          Yetkisiz Erişim
        </h2>

        <p
          style={{
            margin: "12px auto 0",
            maxWidth: 390,
            fontSize: 16,
            lineHeight: 1.6,
            color: "#475569",
            fontWeight: 600,
          }}
        >
          Bu ekranı görüntüleme veya işlem yapma yetkiniz bulunmamaktadır.
        </p>

        <div
          style={{
            marginTop: 22,
            padding: "12px 14px",
            borderRadius: 14,
            background: "#f8fafc",
            color: "#64748b",
            fontSize: 14,
            fontWeight: 700,
            border: "1px solid #e2e8f0",
          }}
        >
          Yetki gerekiyorsa firma yöneticinizden izin talep edebilirsiniz.
        </div>

        <button
          type="button"
          onClick={() => {
            window.location.hash = "#/";
          }}
          style={{
            marginTop: 24,
            border: "none",
            borderRadius: 14,
            padding: "12px 22px",
            background: "linear-gradient(135deg, #2563eb, #1d4ed8)",
            color: "#ffffff",
            fontSize: 15,
            fontWeight: 900,
            cursor: "pointer",
            boxShadow: "0 12px 26px rgba(37, 99, 235, 0.25)",
          }}
        >
          Ana Panele Dön
        </button>
      </div>
    </div>
  </>
);

// ---------------------------------------------------------
// ✔ DOĞRU ROUTE YAPISI – useLocation SORUNSUZ
// ---------------------------------------------------------
export default function AppWrapper() {
  return (
    <HashRouter>
      <Routes>


 {/* 🔓 PUBLIC MENU — LOGIN YOK */}
        <Route path="/menu/:kurumId" element={<PublicMenu />} />
{/* 🔓 PUBLIC MEZARLIK — LOGIN YOK */}
<Route path="/mezarliklar/:kurumId" element={<PublicCemetery />} />

{/* 🔓 PUBLIC GÜZELLİK / KUAFÖR — LOGIN YOK */}
<Route path="/beaty/:kurumId" element={<BeatyMenu />} />

  <Route path="/reset-password" element={<ResetPasswordPage />} />
<Route path="/kurum/reset-password" element={<KurumResetPasswordPage />} />



    {/* 🔐 REFERANS / PANEL RESET (YENİ) */}
  <Route
    path="/referans/reset-password"
    element={<ReferansResetPasswordPage />}
  />

<Route
  path="/network-passport/reset-password"
  element={<ReferansResetPasswordPage />}
/>

<Route
  path="/referans/change-password"
  element={<ReferansChangePasswordPage />}
/>
<Route
  path="/kurum/change-password"
  element={<KurumChangePasswordPage />}
/>
  {/* 🔐 ADMIN PANEL – AYRI */}
<Route path="/admin" element={<AdminLogin />} />

  {/* ✅ REFERANS / KAZANÇ DASHBOARD */}
<Route
  path="/dashboard"
  element={
    localStorage.getItem("user_token")
      ? <ReferansDashboard />
      : <ReferansDashboard />
  }
/>



  {/* 🧑 NORMAL PANEL */}
  <Route path="/*" element={<App />} />
</Routes>

    </HashRouter>
  );
}


// ---------------------------------------------------------
// ✔ ORİJİNAL App (HİÇ BOZULMADAN KORUNDU)
// ---------------------------------------------------------
function App() {
  const [isLoggedIn, setIsLoggedIn] = useState(() => !!localStorage.getItem("token"));
  const provider = dataProvider;

  return isLoggedIn ? (
    <Admin
      dashboard={MuhtarDashboard}
      dataProvider={provider}
      layout={CustomLayout}
      theme={myTheme}
    >
      <Resource
        name="kurumlar"
        list={can("branches.view") ? KurumList : NoPermission}
      />

      <Resource
        name="duyurular"
        list={can("announcements.view") ? DuyurularPage : NoPermission}
        create={can("announcements.manage") ? DuyuruCard : undefined}
        edit={can("announcements.manage") ? DuyuruEdit : undefined}
      />

      <Resource
        name="etkinlikler"
        list={can("events.view") ? EtkinliklerPage : NoPermission}
        create={can("events.manage") ? EtkinlikCreate : undefined}
        edit={can("events.manage") ? EtkinlikEdit : undefined}
      />

      <Resource
        name="anakategoriler"
        list={can("menu.main_categories.view") ? AnaKategorilerPage : NoPermission}
        create={can("menu.main_categories.manage") ? AnaKategoriCreate : undefined}
        edit={can("menu.main_categories.manage") ? AnaKategoriEdit : undefined}
      />

      <Resource
        name="faaliyetler"
        list={can("news.view") ? FaaliyetlerPage : NoPermission}
        create={can("news.manage") ? FaaliyetCreate : undefined}
        edit={can("news.manage") ? FaaliyetEdit : undefined}
      />

      <Resource
        name="iletisim"
        list={can("company.info.manage") ? IletisimPage : NoPermission}
        edit={can("company.info.manage") ? IletisimEdit : undefined}
        create={can("company.info.manage") ? IletisimCreate : undefined}
      />

      <Resource
        name="anketler"
        list={can("surveys.view") ? AnketList : NoPermission}
        create={can("surveys.manage") ? AnketCreate : undefined}
        edit={can("surveys.manage") ? AnketEdit : undefined}
      />

      <Resource
        name="extra-sections"
        list={NoPermission}
        create={can("menu.manage") ? ExtraSectionCreate : undefined}
      />

      <Resource
        name="geribildirimler"
        list={can("feedback.view") ? GeriBildirimlerPage : NoPermission}
        edit={can("feedback.manage") ? GeriBildirimEdit : undefined}
      />

      <Resource name="geribildirim_yanitlari" list={Hidden} create={Hidden} />

      <Resource
        name="evraklarim"
        options={{ label: "📁 Evraklarım" }}
        list={can("files.view") ? Evraklarim : NoPermission}
      />

      <Resource
        name="kullanicilar"
        options={{ label: "Kullanıcılar" }}
        list={can("users.manage") ? KullanicilarPage : NoPermission}
        show={can("users.manage") ? KullaniciShow : NoPermission}
      />

      <CustomRoutes>
        <Route
          path="/bizkimiz"
          element={can("company.info.manage") ? <BizKimizPage /> : <NoPermission />}
        />

        <Route
          path="/ayarlar"
          element={can("settings.view") ? <AyarlarPage /> : <NoPermission />}
        />

        <Route
          path="/randevular"
          element={can("appointments.view") ? <BookingPage /> : <NoPermission />}
        />

        <Route
          path="/restoran-masalar"
          element={can("tables.view") ? <RestaurantTablesPage /> : <NoPermission />}
        />

<Route
  path="/masa-yonetimi"
  element={can("tables.view") ? <MasaYonetimiPage /> : <NoPermission />}
/>
        <Route
          path="/dijital-imza"
          element={can("digital_signature.view") ? <DijitalImzaView /> : <NoPermission />}
        />

        <Route
          path="/evraklarim/sablon-ekle"
          element={can("files.manage") ? <SablonEkle /> : <NoPermission />}
        />

        <Route
          path="/ayarlar/restoran"
          element={can("menu.settings.manage") ? <RestaurantSettingsPage /> : <NoPermission />}
        />

        <Route
          path="/muhasebe"
          element={can("accounting.view") ? <MuhasebeDashboard /> : <NoPermission />}
        />

        <Route
          path="/muhasebe/belgeler"
          element={can("accounting.documents.view") ? <MuhasebeBelgeler /> : <NoPermission />}
        />

        <Route
          path="/muhasebe/sigorta"
          element={can("accounting.insurance.view") ? <SigortaPage /> : <NoPermission />}
        />

        <Route
          path="/qr-kod"
          element={can("menu.view") ? <QrKodPage /> : <NoPermission />}
        />

        <Route
          path="/siparisler"
          element={can("orders.view") ? <SiparislerPage /> : <NoPermission />}
        />

        <Route
          path="/telefon-siparis"
          element={can("orders.view") ? <TelefonSiparisPanel /> : <NoPermission />}
        />

        <Route
          path="/menu-yonetimi"
          element={can("menu.view") ? <MenuYonetimiPage /> : <NoPermission />}
        />

        <Route
          path="/mezarliklar"
          element={can("memorial.view") ? <MezarliklarPage /> : <NoPermission />}
        />

        <Route
          path="/beaty-panel"
          element={can("beauty.view") ? <BeatyPanel /> : <NoPermission />}
        />

        <Route
          path="/kasa-tahsilat"
          element={can("cash.view") ? <KasaPanel /> : <NoPermission />}
        />

        <Route
          path="/cari"
          element={can("current.view") ? <Cari /> : <NoPermission />}
        />

        <Route
          path="/stok-takip"
          element={can("stock.view") ? <StokTakip /> : <NoPermission />}
        />

<Route
  path="/marketplace"
  element={
    can("marketplace.view") ? (
      <MarketplaceYonetimiPage />
    ) : (
      <NoPermission />
    )
  }
/>

        <Route
          path="/entegrasyon"
          element={can("marketplace.view") ? <EntegrasyonPanel /> : <NoPermission />}
        />

        <Route
          path="/yazarkasa"
          element={can("cash.manage") ? <YazarKasaPanel /> : <NoPermission />}
        />

        <Route
          path="/bayilik-sistemi"
          element={can("dealers.view") ? <BayilikSistemi /> : <NoPermission />}
        />

       <Route
  path="/mesaj-merkezi"
  element={can("messages.view") ? <MessageCenter /> : <NoPermission />}
/>

<Route
  path="/is-agi"
  element={
    can("business_network.view") ? (
      <IsAgiPanel />
    ) : (
      <NoPermission />
    )
  }
/>

{/* 🎓 MESYAT KURS, EĞİTİM VE SPOR PROGRAMLARI */}
<Route
  path="/kurs-programlari"
  element={
    can("courses.view") ? (
      <KursPanel />
    ) : (
      <NoPermission />
    )
  }
/>

{/* 🏨 MESYAT HOTEL PRO */}
<Route
  path="/otel-yonetimi"
  element={
    can("hotel.view") ? (
      <HotelYonetimiPage />
    ) : (
      <NoPermission />
    )
  }
/>

{/* 💳 MESYAT PARA / MESPUAN YÖNETİMİ */}
<Route
  path="/mesyat-para-yonetimi"
  element={
    can("mespuan.view") ? (
      <MesyatFrontend />
    ) : (
      <NoPermission />
    )
  }
/>


</CustomRoutes>

      <Resource
        name="ayarlar"
        list={can("settings.view") ? AyarlarPage : NoPermission}
      />


    </Admin>
  ) : (
    <LoginPage onLoginSuccess={() => setIsLoggedIn(true)} />
  );
}